import script from "./FilterBrandsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterBrandsModal.vue?vue&type=script&setup=true&lang=js"

import "./FilterBrandsModal.vue?vue&type=style&index=0&id=3f27706d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f27706d"]])

export default __exports__